import React, { useState } from 'react';
import SoftPhone from '../softphone';
import './style.css';
import {useAuth} from '../../../../app/modules/auth'

function Phone() {
  const {currentUser} = useAuth()
  const [softPhoneOpen, setSoftPhoneOpen] = useState(false);
  const sipConfig = {
    domain: `3dolphins.smartcall.id`,     
    uri: `sip:${currentUser?.extension}@3dolphins.smartcall.id`, 
    password: `${currentUser?.extension}@smartcall1234`,       
    ws_servers: `wss://3dolphins.smartcall.id/ws`, 
    display_name: `${currentUser?.name}`,     
    realm: 'asterisk',
    register: true,
    session_timers: false,
  };

  const [callVolume, setCallVolume] = useState(() => {
    const saved = localStorage.getItem('softphone-call-volume');
    return saved ? parseFloat(saved) : 0.8;
  });
  
  const [ringVolume, setRingVolume] = useState(() => {
    const saved = localStorage.getItem('softphone-ring-volume');
    return saved ? parseFloat(saved) : 0.6;
  });
  
  const [notifications, setNotifications] = useState(() => {
    const saved = localStorage.getItem('softphone-notifications');
    return saved ? JSON.parse(saved) : true;
  });
  
  const [connectOnStart, setConnectOnStart] = useState(() => {
    const saved = localStorage.getItem('softphone-connect-on-start');
    return saved ? JSON.parse(saved) : false;
  });

  // Functions to save settings (implement localStorage if needed)
  const saveConnectOnStart = (value) => {
    setConnectOnStart(value);
    localStorage.setItem('softphone-connect-on-start', value);
  };

  const saveNotifications = (value) => {
    setNotifications(value);
    localStorage.setItem('softphone-notifications', value);
  };

  const saveCallVolume = (value) => {
    setCallVolume(value);
    localStorage.setItem('softphone-call-volume', value);
  };

  const saveRingVolume = (value) => {
    setRingVolume(value);
    localStorage.setItem('softphone-ring-volume', value);
  };

  return (
        <SoftPhone
          softPhoneOpen={softPhoneOpen}
          setSoftPhoneOpen={setSoftPhoneOpen}
          callVolume={callVolume}
          ringVolume={ringVolume}
          connectOnStart={connectOnStart}
          notifications={notifications}
          config={sipConfig}
          setConnectOnStartToLocalStorage={saveConnectOnStart}
          setNotifications={saveNotifications}
          setCallVolume={saveCallVolume}
          setRingVolume={saveRingVolume}
          builtInLauncher={true}
          launcherPosition="bottom-right"
          launcherSize="medium"
          launcherColor="primary"
          asteriskAccounts={[]}
          timelocale="UTC"
        />
  );
}
export {Phone}